document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.mox-tab-button');
  const grids = document.querySelectorAll('.mox-products-grid');
  const addBtn = document.querySelector('.mox-add-to-cart');

  if (!addBtn) return;

  // Activate first tab
  if (tabButtons.length) {
    tabButtons[0].classList.add('active');
    grids[0].classList.add('active');
  }

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabButtons.forEach((b) => b.classList.remove('active'));
      grids.forEach((g) => g.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(target)?.classList.add('active');
      updateTotal();
    });
  });

  function updateTotal() {
    const checked = document.querySelectorAll('.mox-product-checkbox:checked');
    let total = 0;

    checked.forEach((c) => {
      total += parseFloat(
        c.closest('.mox-product-item').dataset.price
      );
    });

    total = total / 100;

    addBtn.innerText = `Agregar productos seleccionados - $${total.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;

    if (checked.length > 0) {
      addBtn.classList.add('is-active');
    } else {
      addBtn.classList.remove('is-active');
    }
  }

  document.querySelectorAll('.mox-product-checkbox').forEach((chk) => {
    chk.addEventListener('change', updateTotal);
  });

  // ---- NUEVA LÓGICA DE ADD TO CART + MINICART ----
  async function addItemsToCart(items) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      await res.json();

      const cartRes = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });

      const cartData = await cartRes.json();

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: cartData },
        })
      );

      const cartTrigger = document.querySelector(
        '.hdt-site-nav_cart a[aria-controls="CartDrawer"]'
      );
      if (cartTrigger) cartTrigger.click();

    } catch (err) {
      console.error('Error agregando productos al carrito:', err);
    }
  }

  addBtn.addEventListener('click', () => {
    const checked = document.querySelectorAll('.mox-product-checkbox:checked');
    if (!checked.length) return;

    const items = [];
    checked.forEach((chk) => {
      const parent = chk.closest('.mox-product-item');
      items.push({
        id: parent.dataset.variant,
        quantity: 1,
      });
    });

    addBtn.innerText = 'Agregando productos...';
    addItemsToCart(items);

    // Reset checkboxes after add to cart
    document.querySelectorAll('.mox-product-checkbox').forEach((chk) => {
      chk.checked = false;
    });

    // Reset button text
    addBtn.innerText = 'Agregar productos seleccionados - $0';
  });
});

// Listener global para refrescar minicart vía Sections API
document.addEventListener('cart:updated', async (e) => {
  try {
    const res = await fetch('/?sections=cart-drawer');
    const data = await res.json();

    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer && data['cart-drawer']) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const newContent = newDoc.querySelector('#CartDrawer .hdt-dialog-drawer__inner');

      const currentContent = cartDrawer.querySelector('.hdt-dialog-drawer__inner');
      if (currentContent && newContent) {
        currentContent.replaceWith(newContent);
      }

      cartDrawer.setAttribute('open', '');
    }

    const cartCountEl =
      document.querySelector('hdt-cart-count') ||
      document.querySelector('.hdt-count-box');

    if (cartCountEl && e.detail?.cart?.item_count !== undefined) {
      const count = e.detail.cart.item_count;
      cartCountEl.textContent = count;

      // Oculta el contador si está en 0
      if (count === 0) {
        cartCountEl.classList.add('hdt-hidden');
      } else {
        cartCountEl.classList.remove('hdt-hidden');
      }
    }
  } catch (err) {
    console.error('Error actualizando minicart:', err);
  }
});
